import { render, staticRenderFns } from "./ChartQuiz.vue?vue&type=template&id=28f17aa1&scoped=true&"
import script from "./ChartQuiz.vue?vue&type=script&lang=js&"
export * from "./ChartQuiz.vue?vue&type=script&lang=js&"
import style0 from "./ChartQuiz.vue?vue&type=style&index=0&id=28f17aa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f17aa1",
  null
  
)

export default component.exports